<mat-expansion-panel (opened)="opened.set(true)" (closed)="opened.set(false)" [class.is-expanded]="opened()"
  class="order-history-accordion">
  <mat-expansion-panel-header class="order-history-accordion-header">
    <mat-panel-title>
      <div class="header-info">
        <div class="supplier-icon"><mat-icon class="icon-store">storefront</mat-icon></div>
        <div class="supplier-details">
          <h3 class="supplier-name text-truncate">{{ item().supplierName }}</h3>
          <span class="product-count-text">
            {{ productCount() }} {{ 'produto' | pluralizador: productCount() }} {{ 'atendido' | pluralizador: productCount() }}
          </span>
        </div>
      </div>
    </mat-panel-title>
    <mat-panel-description class="chip-position">
      <aionz-kanban-chip-badge [label]="chipLabel()" [compact]="true" />
    </mat-panel-description>
  </mat-expansion-panel-header>

  <div class="accordion-content">
    @for (product of item().products; track product.id; let last = $last) {
      <div class="product-content">
        <div class="product-count-text">{{ product.nameProduct }}</div>
      </div>
      @if (!last) {
        <mat-divider />
      }
    }
  </div>


